var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('DisposalOrdersEditBlock',{attrs:{"DO":_vm.DO},on:{"prepareSave":_vm.prepareSave,"saveInDraft":_vm.saveInDraft}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }